var render = function render(_c,_vm){return _c('div',{staticClass:"c-interactive-entrance-btn pws-interaction-entrance",on:{"click":_vm.props.open}},[(_vm.props.icon)?_c('span',{staticClass:"c-interactive-entrance-btn-icon",style:(`background: url(${_vm.props.icon})`)}):_vm._e(),_c('span',[_vm._v(_vm._s(_vm.props.name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }